import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { TransactionEntryLayout } from '../Layouts';

function TransactionEntryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    
    const handleFieldChange = useCallback(() => {
    }, []);
        const handleSelectionChange = useCallback(() => {
    }, []);
    const handleprimaryFormLoad = useCallback(() => {
       props.transactionEntryFormLoad();

    }, []);

    return (
        <div style={{marginTop:"10px"}}>
            <FormField
                currrentUser={currentUser}
                layoutId='319D0B01-5D93-42CD-9934-A165F70EF944'
                layoutName='WMTransactionEntrySetupForm'
                defaultFormSchema={TransactionEntryLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleprimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransactionEntryTab);
